<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <p>已选{{ checkList.length }}条;</p>
      分配至：<el-tag
        title="选择员工"
        class="add-per-input"
        :closable="searchMenNames.length === 0 ? false : true"
        @close="searchCloseTag"
        type="medium"
        effect="plain"
        @click="clickAddMember(true)"
      >
        <span v-if="searchMenNames.length === 0">选择员工</span>
        <span v-for="(item, index) in searchMenNames" :key="index"
          >{{ item.name
          }}<span
            v-show="
              searchMenNames.length > 1 && index != searchMenNames.length - 1
            "
            >,</span
          ></span
        >
      </el-tag>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleDefine" size="mini"
          >执行</el-button
        >
      </span>
    </el-dialog>
    <StaffTree
      :title="treeTitle"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>

<script>
import StaffTree from "@/components/staffTree/staffTree.vue";
import {
  postNewTask,
  postAllocation,
} from "../../../../api/addFriends/addFriends.js";
export default {
  name: "allocateResources",
  data() {
    return {
      dialogVisible: false,
      title: "指定分配当前资源",
      treeTitle: "选择使用成员",
      dialogVisibleTree: false, //成员添加
      searchMenNames: [], //当前 搜索框-选中的成员
      currentSelectMember: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value1: [],
      value2: [],
      checkList: [],
      taskIdList: [],
      userList: [],
    };
  },
  components: { StaffTree },
  methods: {
    async handleDefine() {
      this.checkList.forEach((i) => this.taskIdList.push(i.id));
      const res = await postAllocation(
        { taskId: this.taskIdList, user: this.userList },
        localStorage.getItem("Authorization")
      );
      if (res.error.code == 200) {
        // this.getTagsGroup();
        this.$message({
          type: "success",
          message: "分配成功!",
        });
      } else {
        this.$message({
          type: "warning",
          message: "分配失败!",
        });
      }
      this.dialogVisible = false;
      this.$emit("upload");
      console.log("XXXXXXXXXX", res);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 清空
    searchCloseTag() {
      this.currentSelectMember = [];
      this.searchMenNames = [];
    },
    //树确认回调
    clickSubmitTree(val) {
      console.log("XXXXXXXXXXXXXXXXXXXX", val);
      this.currentSelectMember = val.currentMember;
      this.searchMenNames = val.currentIdName;
      val.sendArray.forEach((item) => {
        this.userList.push({ userId: item.userId, userName: item.userName });
      });
      this.dialogVisibleTree = false;
    },
    // 树
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    // 搜索-添加成员
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.add-per-input {
  margin-right: 10px;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  cursor: pointer;

  .el-icon-close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
  }
}
</style>
